export default "__VITE_ASSET__d1707b27__"